<main class="auth-page">
  <div class="top-row">
    <button type="button" class="back-btn" [attr.aria-label]="'auth.common.backAria' | translate" (click)="goBack()">
      <sz-icon name="arrow-back" [size]="20" />
    </button>
    <sz-brand-block [compact]="true" />
  </div>

  <div class="auth-head">
    <div class="auth-head__kicker">
      <span>{{ 'auth.resetRequest.kicker' | translate }}</span>
    </div>
    <h1 class="auth-head__title">
      {{ 'auth.resetRequest.titleMain' | translate }}
      <span class="auth-head__accent">{{ 'auth.resetRequest.titleAccent' | translate }}</span>
    </h1>
    <p class="auth-head__lead">{{ 'auth.resetRequest.lead' | translate }}</p>
  </div>

  <form class="form" [formGroup]="form" (ngSubmit)="onSubmit()" novalidate>
    <div class="field">
      <div class="field__row">
        <span class="field__label">{{ 'auth.common.fieldEmail' | translate }}</span>
      </div>
      <sz-text-input
        type="email"
        autocomplete="email"
        [placeholder]="'auth.common.emailPlaceholder' | translate"
        prefixIcon="mail"
        formControlName="email"
        [errorText]="emailError()" />
    </div>

    @if (errorMessage(); as msg) {
      <p class="auth-error" role="alert">{{ msg }}</p>
    }

    <button
      type="submit"
      class="cta cta--primary"
      [disabled]="loading() || form.invalid"
      [attr.aria-busy]="loading() ? 'true' : null">
      @if (loading()) {
        <span class="spinner" role="status" [attr.aria-label]="'auth.resetRequest.submitAria' | translate"></span>
      } @else {
        <span>{{ 'auth.resetRequest.submitCta' | translate }}</span>
        <sz-icon name="arrow-right" [size]="16" />
      }
    </button>
  </form>

  <p class="alt">
    {{ 'auth.resetRequest.altPrefix' | translate }}
    <a [routerLink]="loginPath">{{ 'auth.resetRequest.altLink' | translate }}</a>
  </p>
</main>
